<template>
  <div class="blood_collection">
    <van-nav-bar title="采血" v-if="isWx==1" left-arrow @click-left="onClickLeft" fixed></van-nav-bar>
    <van-nav-bar title="采血" v-else fixed></van-nav-bar>
    <div class="navheight"></div>
    <div class="swine_wrap">
        <van-collapse v-model="activeNames">
            <van-collapse-item :title="index + 1 + '、' +item.title" :name="index" v-for="(item,index) in contentList" :key="index">{{item.textItem}}</van-collapse-item>
        </van-collapse>
    </div>
    <Top :btnFlag="btnFlag"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Top from '@/components/top.vue'
export default {
  name: 'bloodcollection',
  components: {
    Top
  },
  data(){
    return{
      btnFlag:false,
      activeNames:[0,1,2],
      contentList:[
        {
          title:'采血目的',
          textItem:'血液抗体和抗原的检测，血液生理生化的检测，血液寄生虫的检测，基因检测，健康评价。',
        },
        {
          title:'猪耳静脉采血',
          textItem:'耳静脉采血法适用于采血量小且保定难度大的大猪、公猪采血，耳缘静脉相对较细、血少且血流速度非常慢，因此会导致采血速度较慢。较大的猪可用保定绳上颌提鼻法保定，小猪可采用侧卧法保定。选择静脉较粗且清晰的耳朵，按压使猪耳静脉血管怒张，采血针头斜面朝上，呈15°角沿耳缘静脉由远心端向近心端刺入血管，见有血液回流后放松按压，缓慢抽取血液或接入真空采血管，一般采取3-5ml。',
        },
        {
          title:'猪前腔静脉采血',
          textItem:'猪前腔静脉采血方法，采血量较猪耳缘静脉更多，耗时更短，采出的血液更干净卫生。取站立或仰卧保定，根据猪的体重选择合适型号的针头，采血部位为小猪在两前肢与气管交汇处，中大猪在胸前口两侧凹陷窝最低处。用75%酒精棉球对采血部位进行螺旋式脱碘消毒，干燥后，持注射器或采血针由右侧沿第1肋骨与胸骨结合部前侧方的凹陷窝处刺入，并稍偏斜刺向中央及胸腔方向，刺入深度依猪体大小而定，一般深约2~6cm。完后左手持酒精棉球紧压针孔，右手拔出针头，涂碘酊按压片刻止血并消毒。',
        }
      ],
      browser: {
        trident: navigator.userAgent.indexOf('Trident') > -1, //IE内核
        presto: navigator.userAgent.indexOf('Presto') > -1, //opera内核
        webKit: navigator.userAgent.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
        gecko: navigator.userAgent.indexOf('Gecko') > -1 && navigator.userAgent.indexOf('KHTML') == -1, //火狐内核
        mobile: !!navigator.userAgent.match(/AppleWebKit.*Mobile.*/) || !!navigator.userAgent.match(/AppleWebKit/), //是否为移动终端
        ios: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
        android: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Linux') > -1, //android终端或者uc浏览器
        iPhone: navigator.userAgent.indexOf('iPhone') > -1 || navigator.userAgent.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
        iPad: navigator.userAgent.indexOf('iPad') > -1, //是否iPad
        webApp: navigator.userAgent.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
      },
      isWx:1,
    };
  },
  created(){
    const ua = window.navigator.userAgent.toLowerCase();
    if(ua.indexOf('micromessenger') == -1) {
      this.isWx = 1
    }else{
      this.isWx = 2
    }
  },
  methods: {
    onClickLeft() {
      this.$router.back(-1)
    },
  }
}
</script>

<style lang="scss">
.blood_collection{
    text-align: left !important;
    .van-nav-bar .van-icon{
        color: #999999;
    }
    .van-cell{
      color:#4C4C4C !important;
      font-size:16px !important;
    }
    .van-collapse-item__content{
      color:#4C4C4C !important;
      font-size:14px !important;
      background:rgba(245,245,245,1) !important;
    }
    .content{
        padding: 15px 14px 10px;
        font-family:PingFangSC-Regular;
        line-height:24px;
        color:rgba(32,32,32,1);
        opacity:1;
    }
}
.van-button--normal {
  width: 40%;
  margin: 10px;
}
.navheight {
  height: 46px;
}
</style>
